<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>System Users Report</h2>
    </div>
    <div class="ibox-content report-box" style="min-height: 125px">
      <div class="row">
        <div class="col-xs-12">
          Generate a report that outputs all users in the system and some details
        </div>
      </div>
    </div>
    <div class="ibox-footer text-right">
      <ladda-button
        :on-click="handleGenerateReport"
        class="btn btn-primary btn-sm">
        <i class="fa fa-cloud-download fa-fw"></i> Download XLS
      </ladda-button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { LaddaButton } from 'components/forms'
  import { notify } from 'utils'

  export default {
    components: {
      LaddaButton
    },

    methods: {
      ...mapActions('report', ['generateSystemUsersReport']),

      handleGenerateReport () {
        const listenForReportGenerated = () => {
          notify.success('Please wait while we get your download ready.')
        }

        return this.generateSystemUsersReport().then(listenForReportGenerated)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SystemUsersReport.vue?b0a6e6f8